import { action, observable } from "mobx";

import MainEntity from "domain/main/MainEntity";

/**
 * [공통관리] 기업관리 Entity
 */
export default abstract class TbCommCorpEntity extends MainEntity {
  @observable bizNo?: string;
  @observable corpNm?: string;
  @observable ceoNm?: string;
  @observable corpSizeCd?: string;
  @observable induCd?: string;
  @observable estaDate?: Date;
  @observable estaFormCd?: string;
  @observable grpNm?: string;
  @observable evalDivCd?: string;
  @observable evalCd?: string;
  @observable corpZipCd?: string;
  @observable corpAddr1?: string;
  @observable corpAddr2?: string;
  @observable homepageUrl?: string;
  @observable acctNo?: string;
  @observable fileId?: string;
  @observable regUserid?: string;
  @observable regDate?: Date;
  @observable modiUserid?: string;
  @observable modiDate?: Date;

  constructor(data?) {
    super(data);
  }

  public getBizNo() {
    return this.bizNo;
  }

  @action
  public setBizNo(bizNo: string) {
    this.bizNo = bizNo;
  }

  public getCorpNm() {
    return this.corpNm;
  }

  @action
  public setCorpNm(corpNm: string) {
    this.corpNm = corpNm;
  }

  public getCeoNm() {
    return this.ceoNm;
  }

  @action
  public setCeoNm(ceoNm: string) {
    this.ceoNm = ceoNm;
  }

  public getCorpSizeCd() {
    return this.corpSizeCd;
  }

  @action
  public setCorpSizeCd(corpSizeCd: string) {
    this.corpSizeCd = corpSizeCd;
  }

  public getInduCd() {
    return this.induCd;
  }

  @action
  public setInduCd(induCd: string) {
    this.induCd = induCd;
  }

  public getEstaDate() {
    return this.estaDate;
  }

  @action
  public setEstaDate(estaDate: Date) {
    this.estaDate = estaDate;
  }

  public getEstaFormCd() {
    return this.estaFormCd;
  }

  @action
  public setEstaFormCd(estaFormCd: string) {
    this.estaFormCd = estaFormCd;
  }

  public getGrpNm() {
    return this.grpNm;
  }

  @action
  public setGrpNm(grpNm: string) {
    this.grpNm = grpNm;
  }

  public getEvalDivCd() {
    return this.evalDivCd;
  }

  @action
  public setEvalDivCd(evalDivCd: string) {
    this.evalDivCd = evalDivCd;
  }

  public getEvalCd() {
    return this.evalCd;
  }

  @action
  public setEvalCd(evalCd: string) {
    this.evalCd = evalCd;
  }

  public getCorpZipCd() {
    return this.corpZipCd;
  }

  @action
  public setCorpZipCd(corpZipCd: string) {
    this.corpZipCd = corpZipCd;
  }

  public getCorpAddr1() {
    return this.corpAddr1;
  }

  @action
  public setCorpAddr1(corpAddr1: string) {
    this.corpAddr1 = corpAddr1;
  }

  public getCorpAddr2() {
    return this.corpAddr2;
  }

  @action
  public setCorpAddr2(corpAddr2: string) {
    this.corpAddr2 = corpAddr2;
  }

  public getHomepageUrl() {
    return this.homepageUrl;
  }

  @action
  public setHomepageUrl(homepageUrl: string) {
    this.homepageUrl = homepageUrl;
  }

  public getAcctNo() {
    return this.acctNo;
  }

  @action
  public setAcctNo(acctNo: string) {
    this.acctNo = acctNo;
  }

  public getFileId() {
    return this.fileId;
  }

  @action
  public setFileId(fileId: string) {
    this.fileId = fileId;
  }

  public getRegUserid() {
    return this.regUserid;
  }

  @action
  public setRegUserid(regUserid: string) {
    this.regUserid = regUserid;
  }

  public getRegDate() {
    return this.regDate;
  }

  @action
  public setRegDate(regDate: Date) {
    this.regDate = regDate;
  }

  public getModiUserid() {
    return this.modiUserid;
  }

  @action
  public setModiUserid(modiUserid: string) {
    this.modiUserid = modiUserid;
  }

  public getModiDate() {
    return this.modiDate;
  }

  @action
  public setModiDate(modiDate: Date) {
    this.modiDate = modiDate;
  }
}
